import { Box, InputBase, Skeleton } from "@mui/material";
import { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";
import LoadingTextBody from "../atoms/LoadingTextBody";

interface TextEditorProps {
  value: string;
  onSave?: () => void;
  onChange?: (value: string) => void;
  loading?: boolean;
}

export default function TextEditor(props: TextEditorProps) {
  const { t } = useTranslation("TextEditor");

  const handleKeyDown = (
    event: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    if (event.ctrlKey && event.key === "s") {
      event.preventDefault();
      props.onSave?.();
    }
  };

  return (
    <Box height={1}>
      {/* <Box
        contentEditable
        p={1}
        bgcolor="background.paper"
        sx={{
          borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
        }}
      >
        {props.value}
      </Box> */}
      {props.loading ? (
        <LoadingTextBody />
      ) : (
        <InputBase
          autoComplete="off"
          value={props.value}
          inputMode="text"
          multiline
          placeholder={t("TypeHere")}
          fullWidth
          sx={{
            height: 1,
            overflow: "auto",
            alignItems: "flex-start",
            // bgcolor: "background.paper",
            borderRadius: (theme) => (theme.shape.borderRadius as number) / 8,
            fontFamily: "monospace",
            p: 1,
          }}
          onKeyDown={handleKeyDown}
          onChange={(e) => props.onChange?.(e.target.value)}
        />
      )}
    </Box>
  );
}
